exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#bg{position:fixed;z-index:0;top:0;left:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover}#bg.bg1{background-position:50%}#bg.bg2{background-position:top}.mobile #bg{display:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/styles/Bg.less
 ** module id = 140
 ** module chunks = 0
 **/